class HospitalAdmission {
  constructor(admissionWithoutConsent, note, patientId, hospitalId) {
    this.admissionWithoutConsent = admissionWithoutConsent;
    this.note = note;
    this.patientId = patientId;
    this.hospitalId = hospitalId;
  }
}
import Vue from 'vue';
export default {
  inject: ['load'],
  data() {
    return {
      hospitalAdmission: new HospitalAdmission(false, '', null, null),
      hospitalAdmissionReport: [],
    };
  },
  methods: {
    getAllHospitalAdmissionsActiveFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllHospitalAdmissionsActive').then(() => {
        if (this.$store.state.hospitalAdmissionModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.hospitalAdmissionModule.allHospitalAdmissionsActive;
          this.hospitalMissions = [];
          for (let i = 0; i < temp.length; i++) {
            let fullName = '';
            let color = '';
            let missionRank = '';
            if (temp[i].missionRank == 0) {
              color = '#D1D1D1';
              missionRank = 'سفید';
            } else if (temp[i].missionRank == 1) {
              color = '#3BCA79';
              missionRank = 'سبز';
            } else if (temp[i].missionRank == 3) {
              color = '#F56060';
              missionRank = 'قرمز';
              if (this.playSoundList.length > 0) {
                let flag = false;
                for (let j = 0; j < this.playSoundList.length; j++) {
                  if (temp[i].id == this.playSoundList[j]) {
                    flag = true;
                  }
                }
                if (flag == false) {
                  this.playSoundList.push(temp[i].id);
                  if (!this.soundIsPlay || !this.redFlag) {
                    this.soundIsPlay = true;
                    clearInterval(this.playInterval);
                    this.playInterval = null;
                    this.playInterval = setInterval(() => {
                      this.playSound();
                    }, 1000);
                    this.redFlag = true;
                  }
                }
              } else {
                this.playSoundList.push(temp[i].id);
                if (!this.soundIsPlay || !this.redFlag) {
                  this.soundIsPlay = true;
                  clearInterval(this.playInterval);
                  this.playInterval = null;
                  this.playInterval = setInterval(() => {
                    this.playSound();
                  }, 1000);
                  this.redFlag = true;
                }
              }
            } else if (temp[i].missionRank == 2) {
              color = '#F2BD27';
              missionRank = 'زرد';
              if (this.playSoundList.length > 0) {
                let flag = false;
                for (let j = 0; j < this.playSoundList.length; j++) {
                  if (temp[i].id == this.playSoundList[j]) {
                    flag = true;
                  }
                }
                if (flag == false) {
                  this.playSoundList.push(temp[i].id);
                  if (!this.soundIsPlay || !this.yellowFlag || !this.redFlag) {
                    this.soundIsPlay = true;
                    this.playInterval = setInterval(() => {
                      this.playSound();
                    }, 2500);
                    this.yellowFlag = true;
                  }
                }
              } else {
                this.playSoundList.push(temp[i].id);
                if (!this.soundIsPlay || !this.yellowFlag || !this.redFlag) {
                  this.soundIsPlay = true;
                  this.playInterval = setInterval(() => {
                    this.playSound();
                  }, 2500);
                  this.yellowFlag = true;
                }
              }
            }
            if (temp[i].patientFirstName) {
              fullName += temp[i].patientFirstName + ' ';
            }
            if (temp[i].patientLastName) {
              fullName += temp[i].patientLastName;
            }
            let allDiagnosis = [];
            if (temp[i].patientDetails) {
              for (let j = 0; j < temp[i].patientDetails.length; j++) {
                if (
                  temp[i].patientDetails[j].typeOfEmergency.title == 'ترومایی مرتبط با حمل و نقل'
                ) {
                  allDiagnosis.push({
                    title: temp[i].patientDetails[j].typeOfEmergency.title,
                    id: j + 1,
                  });
                } else if (
                  temp[i].patientDetails[j].typeOfEmergency.title == 'ترومایی غیرمرتبط با حمل و نقل'
                ) {
                  allDiagnosis.push({
                    title: temp[i].patientDetails[j].typeOfEmergency.title,
                    id: j + 1,
                  });
                } else if (temp[i].patientDetails[j].typeOfEmergency.title == 'بیماری') {
                  if (temp[i].patientDetails[j].diagnosis == 'سکته مغزی') {
                    allDiagnosis.push({
                      title: temp[i].patientDetails[j].diagnosis,
                      id: j + 1,
                    });
                  } else if (temp[i].patientDetails[j].diagnosis == 'مشکلات قلبی') {
                    allDiagnosis.push({
                      title: temp[i].patientDetails[j].diagnosis,
                      id: j + 1,
                    });
                  } else {
                    allDiagnosis.push({
                      title: temp[i].patientDetails[j].diagnosis,
                      id: j + 1,
                    });
                  }
                }
              }
            }
            let diagnosisFlag = false;
            if (allDiagnosis.length > 1) {
              diagnosisFlag = true;
            } else if (allDiagnosis.length == 1) {
              diagnosisFlag = false;
            } else {
              diagnosisFlag = null;
            }
            this.hospitalMissions.push({
              ambulanceCode: temp[i].phoneCode ? temp[i].phoneCode : '-',
              cc: temp[i].missionChiefComplaintText ? temp[i].missionChiefComplaintText : '-',
              diagnosis: temp[i].patientDiagnosis ? temp[i].patientDiagnosis : '-',
              id: temp[i].id,
              fullName: fullName,
              age: temp[i].patientAge ? temp[i].patientAge : '-',
              hospital: temp[i].hospitalTitle ? temp[i].hospitalTitle : '-',
              patientId: temp[i].patientId ? temp[i].patientId : '-',
              missionRank: missionRank,
              color: color,
              rank: temp[i].missionRank,
              allDiagnosis: allDiagnosis,
              diagnosisFlag: diagnosisFlag,
            });
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalAdmissionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllHospitalAdmissionsActiveFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfHospitalAdmissionsWithPaginationReportFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getHospitalAdmissionsWithPaginationReport', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          hospitalId: this.searchHospitalId,
          phoneCode: this.searchAmbulanceCode,
          fullName: this.searchFullName,
          fromDate: this.searchFromDate,
          toDate: this.searchToDate,
        })
        .then(() => {
          if (this.$store.state.hospitalAdmissionModule.successFlag) {
            this.hospitalReportMissions = [];
            let temp = this.$store.state.hospitalAdmissionModule.hospitalAdmissionsReport;
            for (let i = 0; i < temp.length; i++) {
              let fullName = '';
              let color = '';
              let missionRank = '';
              if (temp[i].missionRank == 0) {
                color = '#D1D1D1';
                missionRank = 'سفید';
              } else if (temp[i].missionRank == 1) {
                color = '#3BCA79';
                missionRank = 'سبز';
              } else if (temp[i].missionRank == 2) {
                color = '#F2BD27';
                missionRank = 'زرد';
              } else if (temp[i].missionRank == 3) {
                color = '#F56060';
                missionRank = 'قرمز';
              }
              if (temp[i].patientFirstName) {
                fullName += temp[i].patientFirstName + ' ';
              }
              if (temp[i].patientLastName) {
                fullName += temp[i].patientLastName;
              }
              let date = '';
              if (temp[i].missionCreationDate) {
                date = Vue.moment(temp[i].missionCreationDate).format('HH:mm:ss jYYYY/jM/jD');
              }
              let allDiagnosis = [];
              if (temp[i].patientDetails) {
                for (let j = 0; j < temp[i].patientDetails.length; j++) {
                  if (
                    temp[i].patientDetails[j].typeOfEmergency.title == 'ترومایی مرتبط با حمل و نقل'
                  ) {
                    allDiagnosis.push({
                      title: temp[i].patientDetails[j].typeOfEmergency.title,
                      id: j + 1,
                    });
                  } else if (
                    temp[i].patientDetails[j].typeOfEmergency.title ==
                    'ترومایی غیرمرتبط با حمل و نقل'
                  ) {
                    allDiagnosis.push({
                      title: temp[i].patientDetails[j].typeOfEmergency.title,
                      id: j + 1,
                    });
                  } else if (temp[i].patientDetails[j].typeOfEmergency.title == 'بیماری') {
                    if (temp[i].patientDetails[j].diagnosis == 'سکته مغزی') {
                      allDiagnosis.push({
                        title: temp[i].patientDetails[j].diagnosis,
                        id: j + 1,
                      });
                    } else if (temp[i].patientDetails[j].diagnosis == 'مشکلات قلبی') {
                      allDiagnosis.push({
                        title: temp[i].patientDetails[j].diagnosis,
                        id: j + 1,
                      });
                    } else {
                      allDiagnosis.push({
                        title: temp[i].patientDetails[j].diagnosis,
                        id: j + 1,
                      });
                    }
                  }
                }
              }
              let diagnosisFlag = false;
              if (allDiagnosis.length > 1) {
                diagnosisFlag = true;
              } else if (allDiagnosis.length == 1) {
                diagnosisFlag = false;
              } else {
                diagnosisFlag = null;
              }
              this.hospitalReportMissions.push({
                ambulanceCode: temp[i].phoneCode ? temp[i].phoneCode : '-',
                date: date,
                id: temp[i].id,
                fullName: fullName,
                address: temp[i].address ? temp[i].address : '-',
                hospital: temp[i].hospitalTitle ? temp[i].hospitalTitle : '-',
                patientId: temp[i].patientId ? temp[i].patientId : null,
                missionRank: missionRank,
                color: color,
                rank: temp[i].missionRank,
                allDiagnosis: allDiagnosis,
                diagnosisFlag: diagnosisFlag,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.hospitalAdmissionModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.hospitalAdmissionModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.hospitalAdmissionModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.hospitalAdmissionModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfHospitalAdmissionsWithPaginationReportFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addHospitalAdmissionFunction: function () {
      if (!this.hospitalAdmission.note) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.hospitalAdmission.note.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.hospitalAdmission.hospitalId) {
        this.snackText = 'بیمارستان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.hospitalAdmission.patientId = Number(this.patientId);
      this.hospitalAdmission.hospitalId = Number(this.hospitalAdmission.hospitalId);
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addHospitalAdmission', this.hospitalAdmission).then(() => {
        if (this.$store.state.hospitalAdmissionModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.admissionModal = false;
          this.disabelConfirm = false;
          this.snackText = ' مددجو با موفقیت پذیرش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.hospitalAdmission = new HospitalAdmission(false, '', null, null);
          this.getAllHospitalAdmissionsActiveFunction();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.hospitalAdmissionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addHospitalAdmissionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.hospitalAdmissionModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
